exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-28f03810] .uploader-btn,[data-v-28f03810] .uploader-drop{background-color:var(--contentBgColor)}[data-v-28f03810] .uploader-btn{border:1px dashed var(--lineBorderColor);border-radius:6px}[data-v-28f03810] .uploader-btn:hover{border-color:var(--uploadHoverColor)}.tip[data-v-28f03810]{margin:0;color:#939696;font-size:12px}", ""]);

// exports
